export const TOKEN_KEY = `genedata_auth_token${import.meta.env.DEV ? "" : `_${location.pathname.split("/")[1]}`}`;

export const getCredentialsHeaders = (): HeadersInit => {
  const token = localStorage.getItem(TOKEN_KEY);

  return token
    ? {
        Authorization: `Bearer ${token}`,
        "X-Authorization": `Bearer ${token}`,
      }
    : {};
};
